import React from "react";

export const Highlight = ({ children, className }: any) => {
  return (
    <span className="inline-block underline decoration-green-500/50 decoration-[3px] break-all">
      {children}
    </span>
  );
};
